<template>
  <div>
    <!-- 背景图 -->
    <div class="top">
      <div class="t-t1">行业案例</div>
      <div class="t-t2box">
        <div class="t-t2">海量企业 通过谛听完美解决需求</div>
      </div>
    </div>

    <div class="box">
      <div class="title">
        <div class="t1">班组建设管理标准化及基层管理者能力提升</div>

        <div class="t2">
          <div class="t2-time">2022-06-15</div>
          <div class="t2-text">智能家居 | 全网营销</div>
        </div>

        <div class="line"></div>
      </div>
      <!-- 一 -->
      <div class="item">
        <!-- 标题 -->
        <div class="biaotitle">
          <div class="bt">客户介绍</div>
        </div>

        <div class="textbox">
          <div class="t1">该公司是一家国有的写字楼物业管理公司，所管理物业为建筑面积1.6万平方米的5A级写字楼。</div>
        </div>
      </div>

      <!-- 二 -->
      <div class="item">
        <!-- 标题 -->
        <div class="biaotitle">
          <div class="bt">项目需求及主要问题</div>
        </div>

        <div class="textbox2">
          <div class="t1">客户当前为题主要集中在现有的培养管理支撑业务不足，具体表现在以下方面：</div>
          <div class="t1">1、市场化况比较明显，与康瑞普接轨存在一定问题。</div>
          <div class="t1">2、人员的配置过少，导致加班严重，且内部员工为了加班，新进人员会被挤兑，引入 新人困哪。</div>
          <div class="t1">3、薪酬架构非常不合理</div>
          <div class="t1">4、绩效考核比较规范，但与康瑞普合并后需要酌情考量。</div>
        </div>
      </div>

      <!-- 三 -->
      <div class="item">
        <!-- 标题 -->
        <div class="biaotitle">
          <div class="bt">解决方案</div>
        </div>

        <div class="textbox">
          <div class="t1">1、首先对其进行人力资源进行全面盘点</div>
          <div class="img">
            <img src="@/image/IndustryCases/Cases/tu47@2x.png" alt="" />
          </div>
          <div class="t1">2.在诊断基础上进行组织架构与岗位的系统梳理</div>
          <div class="img">
            <img src="@/image/IndustryCases/Cases/tu48@2x.png" alt="" />
          </div>

          <div class="t1">3.在组织岗位基础上，对其薪酬体系优化设计</div>

          <div class="img">
            <img src="@/image/IndustryCases/Cases/tu49@2x.png" alt="" />
          </div>

          <div class="t1">4.针对浮动薪酬与绩效体系有效衔接</div>
          <div class="img">
            <img src="@/image/IndustryCases/Cases/tu50@2x.png" alt="" />
          </div>
        </div>

        <div class="biaotitle">
          <div class="bt">实施效果</div>
        </div>
        <div class="textbox" style="color: #4581fb">
          <div class="t1">结合诊断的结果，针对客户相对比较痛的内容进行了全面的梳理，并制定了针对性解决方案。</div>
        </div>

        <div class="line2"></div>

        <!-- 上下页 -->
        <div class="change">
          <div class="chang1">
            上一页：
            <div class="c1">新工厂精益布局规划</div>
          </div>
          <div class="chang1">
            下一页：
            <div class="c1">新工厂精益布局规划</div>
          </div>
        </div>
        <!-- 上下页end----------- -->
      </div>
    </div>

    <!-- 推荐 -->
    <div class="tuij">
      <!-- 标题 -->
      <div class="tuij-text">为您推荐</div>
      <!-- 推荐列表 -->
      <div class="tuij-box">
        <!-- 推荐项 -->
        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>
        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>
        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>
        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>
        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>
        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>

        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>
        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>

        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>
        <div class="tuij-item">
          <!-- 左边 -->
          <div class="left">
            <div class="dian"></div>
            <div class="tuij-name">通用8D改善方法应用技巧</div>
          </div>

          <!-- 右边时间 -->
          <div class="tuij-time">[2022-06-15 20:00:00]</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DczxxXiangqin',

  data() {
    return {}
  },

  mounted() {},

  methods: {},
}
</script>

<style lang="scss" scoped>
.top {
  z-index: -1;
  position: relative;
  height: 480px;
  background-image: url('@/image/IndustryCases/bj.png');
  background-repeat: no-repeat;

  .t-t1 {
    font-size: 60px;
    color: #000;
    position: absolute;
    z-index: 100;
    top: 28%;
    left: 20%;
  }

  .t-t2box {
    padding-left: 5px;
    color: #666666;
    z-index: 100;
    position: absolute;
    top: 48%;
    left: 20%;
    .t-t2 {
      font-size: 24px;
      margin: 10px 0;
    }
  }
}

.box {
  width: 100%;
  .title {
    margin: 50px auto;
    width: 1300px;
    text-align: center;
    position: relative;

    .t1 {
      font-size: 38px;
      letter-spacing: 4px;
      font-weight: 600;
    }
    .t2 {
      position: absolute;
      display: flex;
      left: 50%;
      transform: translateX(-50%);
      top: 90px;
      color: #999999;
      font-size: 14px;

      .t2-text {
        color: #4581fb;
        margin-left: 30px;
      }
    }

    .line {
      height: 2px;
      width: 1360px;
      background-color: #fafafa;
      position: absolute;
      top: 130px;
    }
  }

  .item {
    width: 1200px;
    margin: 125px auto -80px auto;
    position: relative;

    .biaotitle {
      height: 40px;
      width: 300px;
      margin: 0px auto 20px auto;
      text-align: center;

      line-height: 40px;

      .bt {
        // margin: 20px auto 40px auto;

        font-size: 26px;
        margin-bottom: 30px;
      }
    }

    .textbox {
      .t1 {
        width: 1220px;
        margin: 0px auto;
        margin-bottom: 8px;
        letter-spacing: 1px;
        color: #333333;
        font-size: 16px;

        text-align: center;
      }
    }

    .textbox2 {
      margin: 0 auto;
      width: 640px;
      .t1 {
        width: 1220px;

        margin-bottom: 8px;
        letter-spacing: 1px;
        color: #333333;
        font-size: 15px;
      }
    }

    .img {
      width: 550px;
      margin: 30px auto;
      img {
        width: 100%;
      }
    }

    .line2 {
      height: 2px;
      width: 1360px;
      background-color: #fafafa;
      margin-top: 35px;
      margin-left: -30px;
    }
  }

  .change {
    position: absolute;
    bottom: -50px;

    left: 100px;

    display: flex;
    width: 1000px;

    justify-content: space-between;

    .chang1 {
      display: flex;
      font-size: 15px;
    }
    .c1:hover {
      color: #4581fb;
    }
  }
}

.tuij {
  margin-top: 250px;
  height: 450px;
  background-color: #f7f8fb;
  overflow: hidden;

  .tuij-text {
    width: 200px;
    text-align: center;
    margin: 50px auto;
    font-size: 25px;
  }

  .tuij-box {
    width: 1000px;
    height: 300px;

    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .dian {
      margin-top: 6px;
      margin-right: 5px;
      background-color: #4581fb;
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }

    .tuij-item {
      width: 450px;

      display: flex;

      .left {
        display: flex;

        .tuij-name {
          font-size: 15px;
        }
      }

      .tuij-time {
        margin-left: 100px;
        font-size: 13px;
        color: #999999;
      }
    }
  }
}
</style>
